function hideResults()
{
      var resultmessage1,resultmessage2;   
      resultmessage1 = document.querySelector('p.js-size-message1'); 
      resultmessage2 = document.querySelector('p.js-size-message2'); 

      if(resultmessage1){
          resultmessage1.querySelector('span.menCategory').innerHTML = "";
          resultmessage1.querySelector('span.womenCategory').innerHTML = "";
      }
      if(resultmessage2){
          resultmessage2.querySelector('span.menCategory').innerHTML = "";
          resultmessage2.querySelector('span.womenCategory').innerHTML = "";
      }
}

// $(document).on("input", "#ring_slide", function() {
$('#ring_slide').on('input', function() { 

  
     showResults(2);
     //hideResults();
  
    $('#ring_size').html(this.value); 
  
    var circumference = (this.value);

    //circumference = mmToPxCSS(this.value)
   

    var diameter = (circumference/3.14159) + 15 + 'mm';
  
    $('.ring_img').css({
        'width': diameter,
    });
 
});



function mmToPxCSS(mm) {
  const div = document.createElement("div");
  div.style.width = mm + "mm";
  div.style.position = "absolute";
  div.style.visibility = "hidden";
  document.body.appendChild(div);
  const pixels = div.getBoundingClientRect().width;
  document.body.removeChild(div);
  return pixels;
}



 
function gotoStep(number){
  document.querySelectorAll('.interfaces').forEach(item => {
    item.classList.remove('active');
  });
  document.querySelector(`.interfaces[data-step='${number}']`).classList.add('active');
}



/* range slider */
(function() {
	var parent = document.querySelector("#rangeSlider");
	if(!parent) return;

	var
      range = parent.querySelector("input[type=range]"),
      numberS = parent.querySelectorAll("input[type=number]");
      range.oninput = function() {
        var slide = parseFloat(range.value);
        numberS[0].value = slide;

        showResults(1);
        //hideResults();
        
        document.querySelector('.js-output-range').innerHTML=slide; 
 
      }

	numberS.forEach(function(el) {
		el.oninput = function() {
			var number1 = parseFloat(numberS[0].value),
				number2 = parseFloat(numberS[1].value);

			if (number1 > number2) {
				var tmp = number1;
				numberS[0].value = number2;
				numberS[1].value = tmp;
			}

			rangeS[0].value = number1;
			rangeS[1].value = number2; 
          
		}
	});

  })();



/* results */
function showResults(decide){
    var sizeinmm = 30;
  
    if(decide == 1){
      sizeinmm = parseInt(document.querySelector('input#range-input').value);
    }else{
      sizeinmm = parseInt(document.querySelector('input#ring_slide').value);
    }
 

      var sizeGuideForWomen = "S",sizeGuideFormen = "S";

 
 /*
 // MEN S(56),M(60),L(64)
      if(sizeinmm >= 61)
      {
        // 61 and above -> L
        sizeGuideFormen="64";
      }else if(sizeinmm >= 57)
      {
        // 57 and above till 60 -> M
        sizeGuideFormen="60";
      }else{
        // Below 57 -> S
        sizeGuideFormen="56";
      }
*/

//54-64
switch(sizeinmm){case 64:case 63:case 62:case 61:sizeGuideFormen="64";break;case 60:case 59:case 58:case 57:sizeGuideFormen="60";break;default:sizeGuideFormen="56"}

    
 /*
      // WOMEN XXS(48),XS(50),S(52),M(54),L(56),XL(58),XXL(60)
      if(sizeinmm >= 59)
      {
        // 59 and above -> XXL
        sizeGuideForWomen="60";
      }else if(sizeinmm >= 57)
      {
        // 57 and above -> XL
        sizeGuideForWomen="58";
      }else if(sizeinmm >= 55)
      {
        // 55 and above -> L
        sizeGuideForWomen="56";
      }else if(sizeinmm >= 53)
      {
        // 53 and above -> M
        sizeGuideForWomen="54";
      }else if(sizeinmm >= 51)
      {
        // 51 and above -> S
        sizeGuideForWomen="52";
      }else if(sizeinmm >= 49)
      {
        // 49 and above -> XS
        sizeGuideForWomen="50";
      }else
      {
        // Below 49 -> XXS
        sizeGuideForWomen="48";
      }
*/
    
//45-60
switch(sizeinmm){case 60:case 59:sizeGuideForWomen="60";break;case 58:case 57:sizeGuideForWomen="58";break;case 56:case 55:sizeGuideForWomen="56";break;case 54:case 53:sizeGuideForWomen="54";break;case 52:case 51:sizeGuideForWomen="52";break;case 50:case 49:sizeGuideForWomen="50";break;default:sizeGuideForWomen="48"}


      var resultmessage;  

      if(decide == 1){
        resultmessage = document.querySelector('p.js-size-message1');
      }else{
        resultmessage = document.querySelector('p.js-size-message2');
      }

     resultmessage.classList.remove('hidden');
  
     resultmessage.querySelector('span.menCategory').innerHTML = sizeGuideFormen;
     resultmessage.querySelector('span.womenCategory').innerHTML = sizeGuideForWomen;
 
 
      //alert(sizeGuideFormen+ "--" + sizeGuideForWomen);
  
  
    //var modal = document.getElementById("myModal");
    //modal.style.display = "none";
    
    //if(document.querySelector('video.viodeofaq'))document.querySelector('video.viodeofaq').pause();

    //gotoStep(0);
 
}






var tagSelection = "";
var modalval= document.querySelector('#myModal');
if(modalval){
  if(modalval.dataset.tagoption == "men"){
    tagSelection = "men";
  }else if(modalval.dataset.tagoption == "women"){
    tagSelection = "women";
  }
}

var mainDecisionForMen = false;

if(localStorage.getItem('selectionValue') == "men"){
  mainDecisionForMen = true;
}
if(tagSelection == "men"){
  mainDecisionForMen = true;
}



function normalText(){
  var normalTX = document.querySelectorAll('.interfaces .normalTXv');
  var hisherTX = document.querySelectorAll('.interfaces .hisherTXv');

  normalTX.forEach(item => {
    item.classList.remove('hidden');
  });

  hisherTX.forEach(item => {
    item.classList.add('hidden');
  }); 
}
function hisHerText(){
  var normalTX = document.querySelectorAll('.interfaces .normalTXv');
  var hisherTX = document.querySelectorAll('.interfaces .hisherTXv');

  normalTX.forEach(item => {
    item.classList.add('hidden');
  });

  hisherTX.forEach(item => {
    item.classList.remove('hidden');
  }); 
}


var changeEvent = new Event('change', { bubbles: true });

if(mainDecisionForMen){
  //men
  var firstOne = document.querySelector("#ring_slide");
  if(firstOne){
   firstOne.setAttribute("min",54);
   firstOne.setAttribute("max",64);
  }

  var secondOne = document.querySelector("#range-input");
  if(secondOne){
   secondOne.setAttribute("min",54);
   secondOne.setAttribute("max",64);
  }

  firstOne.dispatchEvent(changeEvent);
  secondOne.dispatchEvent(changeEvent);  
}else{
  //women
  var firstOne = document.querySelector("#ring_slide");
  if(firstOne){
   firstOne.setAttribute("min",45);
   firstOne.setAttribute("max",60);
  }

  var secondOne = document.querySelector("#range-input");
  if(secondOne){
   secondOne.setAttribute("min",45);
   secondOne.setAttribute("max",60);
  }

  firstOne.dispatchEvent(changeEvent);
  secondOne.dispatchEvent(changeEvent);
}








